import {Injectable, computed, inject, signal} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {UserService} from '../user/user.service';

const STORAGE_KEY = 'pantry.dialog.debugEnabled';

function readStoredEnabled(): boolean {
  if (typeof localStorage === 'undefined') return false;
  return localStorage.getItem(STORAGE_KEY) === 'true';
}

/**
 * Admin-only debug mode for the dialog widget: exposes the raw context token,
 * per-turn wire state, and timing. `enabled` persists across reloads
 * (`localStorage`, same pattern as `ViewContextService`), but `active` also
 * requires the *current* user to be an admin — so a flag left on from a
 * previous admin session on a shared browser never surfaces debug data to
 * whoever's logged in next.
 */
@Injectable({providedIn: 'root'})
export class DialogDebugService {
  private readonly userService = inject(UserService);

  readonly isAdmin = toSignal(this.userService.isAdmin$(), {initialValue: false});

  private readonly _enabled = signal<boolean>(readStoredEnabled());
  readonly enabled = this._enabled.asReadonly();

  readonly active = computed(() => this.isAdmin() && this._enabled());

  setEnabled(value: boolean): void {
    this._enabled.set(value);
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, String(value));
    }
  }
}
